import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./quasar";
import axios from "axios";

Vue.config.productionTip = false;
axios.defaults.baseURL =
  process.env.VUE_APP_API_PATH || "http://localhost:8000/api";
axios.defaults.headers.common["Authorization"] =
  process.env.AUTHORIZATION || "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9";

//Truncate text
const filter = function(text: any, length: any, clamp: any) {
  clamp = clamp || "...";
  const node = document.createElement("div");
  node.innerHTML = text;
  const content = node.textContent;
  if (content) {
    return content.length > length ? content.slice(0, length) + clamp : content;
  } else {
    return text;
  }
};
Vue.filter("truncate", filter);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
